/**
 * Preload helper for route components
 */
export async function preloadComponent(component) {
  try {
    // Handle both lazy-loaded and direct components
    const comp = await (typeof component === "function"
      ? component()
      : component);

    // Check if the component has a preload method
    if (comp?.default?.preload) {
      console.log("Preloading component assets...");
      await comp.default.preload();
      console.log("Component preload completed");
    }
  } catch (error) {
    console.warn("Failed to preload component:", error);
    // Don't throw - fail gracefully
  }
}
